import React, { useCallback } from 'react';
import { NavLinkProps as RouterNavLinkProps, NavLink as RouterNavLink, useNavigate } from 'react-router-dom';

/**
 * Wrapper around react router link that automatically handles service worker updates
 * See https://zach.codes/handling-client-side-app-updates-with-service-workers/
 */
type NavLinkProps = {
  onClick?: () => void;
} & RouterNavLinkProps;

export default function NavLink({ to, onClick, ...otherProps }: NavLinkProps) {
  const navigate = useNavigate();
  const handleClick = useCallback(
    (e: any) => {
      if (e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      // @ts-ignore
      if (window?.swUpdate) {
        // @ts-ignore
        window.location = to;
      }
      if (onClick) {
        onClick(e);
      }
      navigate(to);
    },
    [navigate, onClick, to],
  );

  return <RouterNavLink to={to} onClick={handleClick} {...otherProps} />;
}
NavLink.defaultProps = {
  onClick: () => {},
};
